require('./helpers/bundle-manifest').register(JSON.parse("{\"3NnHV\":\"app.js\",\"jg7e3\":\"vacancies-feed.89d769a6.js\",\"2nvXT\":\"styles.e01b1d60.js\"}"));